const { TRANSLATED_UGC_URL, FLOWS } = require('../utils/constants');

const TRANSLATION_CONTEXT = {
    GENERAL: 'general',
    SEARCH: 'search'
};

const SUB_CATEGORY_SUB_HEADER = { component: { name: 'sub_category_sub_header' } };
const SEARCH_SUB_HEADER = { component: { name: 'search_sub_header' } };
const FLOWS_BI_DATA_UGC_MAPPER = {
    [FLOWS.CATEGORY]: { name: 'sub_category', ...SUB_CATEGORY_SUB_HEADER },
    [FLOWS.SEARCH]: { name: 'search_gigs', ...SEARCH_SUB_HEADER },
    [FLOWS.PRO_CATEGORY]: { name: 'pro_sub_category', ...SUB_CATEGORY_SUB_HEADER }
};

const buildTranslationConfig = (translateUGC, locale, userId, knownCrawler, flow) => {

    if (!translateUGC || knownCrawler) {
        return undefined;
    }

    return {
        translationServiceUrl: TRANSLATED_UGC_URL,
        locale,
        knownCrawler,
        sourceInfo: {
            ...FLOWS_BI_DATA_UGC_MAPPER[flow],
            user: {
                id: userId
            }
        }
    };
};

const createBiData = ({ userId = '', userGuid = '', flow }) => ({
    ...FLOWS_BI_DATA_UGC_MAPPER[flow],
    user: {
        id: userId
    },
    userGuid
});

const createSearchQueryBiData = ({ userId = '', userGuid = '' }) => ({
    name: 'search_gigs',
    component: { name: 'search_query' },
    context: TRANSLATION_CONTEXT.SEARCH,
    user: {
        id: userId
    },
    userGuid
});

module.exports = {
    buildTranslationConfig,
    createBiData,
    createSearchQueryBiData,
    TRANSLATION_CONTEXT
};
